import { useMemo } from 'react';
import i18next from 'i18next';

import { Locale } from 'chaika-enums';
import { TranslationValues } from 'chaika-translation-data';

import { isDefined } from '@utils/isDefined';
import { getLocaleArray } from '@utils/CommonOptionType';

type VariableName = `$${string}`;

export function getTranslate(key: TranslationValues, locale?: Locale): string {
    return locale ? getTranslateByLocale(locale, key) : translate(key);
}

export function translate(key: TranslationValues, variables?: Record<VariableName, string>): string {
    const isExist = i18next.exists(key);

    let translation = isExist ? i18next.t(key) : (key as string);

    if (isDefined(variables)) {
        Object.entries(variables).forEach(([variableName, value]) => {
            translation = translation.replaceAll(variableName, value);
        });
    }

    return translation;
}

export function getTranslateByLocale(locale: Locale, key: TranslationValues): string {
    const translations = i18next.getDataByLanguage(locale);
    const isExist = isDefined(translations) && isDefined(translations.translation?.[key]);

    return isExist ? translations.translation[key] : (key as string);
}

export function getTranslatesForAllLocales(key: TranslationValues): string[] {
    return getLocaleArray().map(locale => getTranslateByLocale(locale, key));
}

/**
 * Значение из набора переводов, пришедшего с бэкенда: свой язык, затем английский, затем русский.
 * Пустая строка равнозначна отсутствию перевода.
 */
export function pickLocaleValue(translations: Partial<Record<Locale, string>>): string | undefined {
    return translations[i18next.language as Locale] || translations[Locale.En] || translations[Locale.Ru] || undefined;
}

export function useMemoTranslations<T>(tr: T): T {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo<T>(() => tr, [i18next.language]);
}
